(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-cat-cases-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__amci) return;
      root.__amci = true;
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-amci-pick]'));
      var layers = Array.prototype.slice.call(root.querySelectorAll('[data-amci-layer]'));
      function pick(i) {
        thumbs.forEach(function (t, k) { t.setAttribute('aria-checked', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        layers.forEach(function (l, k) { l.classList.toggle('is-on', k === i); });
      }
      var current = Math.max(0, thumbs.findIndex(function (t) { return t.getAttribute('aria-checked') === 'true'; }));
      thumbs.forEach(function (t, k) {
        t.tabIndex = k === current ? 0 : -1;
        t.addEventListener('click', function () { current = k; pick(k); });
        t.addEventListener('keydown', function (e) {
          var n = thumbs.length, next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % n;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + n) % n;
          if (next === null) return;
          e.preventDefault(); current = next; pick(next); thumbs[next].focus();
        });
      });
      root.__amciPick = function (i) { current = i; pick(i); };
    }
    function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-amci]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var i = e.target && e.target.getAttribute && e.target.getAttribute('data-amci-pick');
      var root = e.target && e.target.closest && e.target.closest('[data-amci]');
      if (i !== null && i !== undefined && root && root.__amciPick) root.__amciPick(parseInt(i, 10));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-cat-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FEED = 'am-cat-feed';

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function init(root) {
      if (!root || root.__amc) return;
      var grid = root.querySelector('[data-amc-grid]');
      var cfgEl = root.querySelector('[data-amc-config]');
      if (!grid || !cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      root.__amc = true;

      var pills = Array.prototype.slice.call(root.querySelectorAll('[data-amc-pill]'));
      var moreWrap = root.querySelector('[data-amc-more-wrap]');
      var moreBtn = root.querySelector('[data-amc-more]');
      var moreLabel = root.querySelector('[data-amc-more-label]');
      var moreText = moreLabel ? moreLabel.textContent : '';
      var countEl = root.querySelector('[data-amc-count]');
      var totalEl = root.querySelector('[data-amc-total]');
      var emptyEl = root.querySelector('[data-amc-empty]');
      var errorEl = root.querySelector('[data-amc-error]');
      var sortEl = root.querySelector('[data-amc-sort]');
      var per = cfg.perLoad || 12;
      var themes = cfg.themes || [];
      var byHandle = {};
      themes.forEach(function (t) { byHandle[t.handle] = t; });
      var bySlug = {};
      themes.forEach(function (t) { if (t.filter && !bySlug[t.slug]) bySlug[t.slug] = t; });
      var base = (cfg.collectionsUrl || '/collections').replace(/\/$/, '');
      var sort = '';
      var states = {};
      var current = 'all';

      /* ---------- sources: one real Shopify collection each, read page by page ---------- */
      function sourcesFor(key) {
        var list = [];
        if (key === 'all') {
          if (cfg.main) list.push(cfg.main.handle);
          if (!cfg.main || cfg.scanThemes) themes.forEach(function (t) { if (list.indexOf(t.handle) < 0) list.push(t.handle); });
        } else if (bySlug[key]) {
          list.push(bySlug[key].handle);
        }
        return list.map(function (h) { return { handle: h, page: 0, pages: 1, done: false }; });
      }
      function knownTotal(st) {
        if (st.done) return st.seen.size;
        if (st.key === 'all') {
          if (cfg.main) return Math.max(cfg.main.count, st.seen.size);
          return null;
        }
        var t = bySlug[st.key];
        return t ? t.count : null;
      }
      function newState(key) {
        return { key: key, sources: sourcesFor(key), si: 0, seen: new Set(), buffer: [], cards: [], done: false, queue: Promise.resolve(), error: false, showError: false };
      }

      /* ---------- the first batch is already in the page ---------- */
      function adoptServerCards(st) {
        Array.prototype.forEach.call(grid.querySelectorAll('[data-amc-card]'), function (c) {
          var id = c.getAttribute('data-id');
          if (id) st.seen.add(id);
          st.cards.push(c);
        });
      }

      function feedUrl(handle, page) {
        var u = base + '/' + encodeURIComponent(handle) + '?section_id=' + FEED + '&page=' + page;
        if (sort) u += '&sort_by=' + encodeURIComponent(sort);
        return u;
      }
      function fetchPage(st) {
        var src = st.sources[st.si];
        if (!src) { st.done = true; return Promise.resolve(); }
        var page = src.page + 1;
        return fetch(feedUrl(src.handle, page), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-amc-feed]');
            var data = node ? JSON.parse(node.getAttribute('data-json') || '{}') : { items: [], pages: 0 };
            var items = data.items || [];
            src.page = page;
            src.pages = data.pages || 0;
            items.forEach(function (it) {
              var id = String(it.id);
              if (st.seen.has(id)) return;
              st.seen.add(id);
              st.buffer.push(it);
            });
            if (!items.length || page >= src.pages) {
              src.done = true;
              st.si += 1;
              if (st.si >= st.sources.length) st.done = true;
            }
          });
      }
      /* Make sure the buffer holds at least `want` products (or the sources are exhausted). Calls are queued. */
      function fill(st, want) {
        st.queue = st.queue.then(function loop() {
          if (st.buffer.length >= want || st.done) return;
          return fetchPage(st).then(loop);
        }).then(function () { st.error = false; }, function () { st.error = true; });
        return st.queue;
      }

      /* ---------- cards built from feed data, same markup as snippets/am-cat-card.liquid ---------- */
      function tagsFor(handles) {
        var out = [];
        (handles || []).forEach(function (h) { var t = byHandle[h]; if (t && t.filter && out.indexOf(t) < 0) out.push(t); });
        return out;
      }
      function buildCard(it) {
        var card = el('article', 'amc-card');
        card.setAttribute('data-amc-card', '');
        card.setAttribute('data-id', String(it.id));
        card.setAttribute('data-handles', (it.handles || []).join(','));
        var tags = tagsFor(it.handles);
        card.setAttribute('data-themes', tags.map(function (t) { return t.slug; }).join(' '));
        var media = el('a', 'amc-card__media');
        media.href = it.url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
        if (it.img) {
          var im = el('img');
          im.src = it.img; if (it.srcset) im.srcset = it.srcset; im.sizes = cfg.sizes;
          im.loading = 'lazy'; im.decoding = 'async'; im.alt = it.alt || it.title || '';
          if (it.w && it.h) { im.width = it.w; im.height = it.h; }
          media.appendChild(im);
          if (it.img2) {
            var im2 = el('img', 'amc-card__alt');
            im2.src = it.img2; if (it.srcset2) im2.srcset = it.srcset2; im2.sizes = cfg.sizes;
            im2.loading = 'lazy'; im2.decoding = 'async'; im2.alt = '';
            media.appendChild(im2);
          }
        }
        card.appendChild(media);
        if (cfg.showTags && tags.length) {
          var box = el('div', 'amc-card__tags');
          tags.slice(0, cfg.maxTags || 2).forEach(function (t) {
            var b = el('button', 'amc-tag', t.label);
            b.type = 'button'; b.setAttribute('data-amc-tag', t.slug);
            b.style.setProperty('--amc-tb', t.bg); b.style.setProperty('--amc-tt', t.fg);
            box.appendChild(b);
          });
          card.appendChild(box);
        }
        var title = el('a', 'amc-card__title', it.title);
        title.href = it.url;
        card.appendChild(title);
        if (cfg.showPrice) {
          var price = el('span', 'amc-card__price');
          if (it.varies && cfg.fromLabel) price.appendChild(document.createTextNode(cfg.fromLabel + ' '));
          if (it.compareText) price.appendChild(el('s', null, it.compareText));
          price.appendChild(document.createTextNode(it.priceText || ''));
          if (it.available === false && cfg.soldOutLabel) price.appendChild(document.createTextNode(' · ' + cfg.soldOutLabel));
          card.appendChild(price);
        }
        return card;
      }

      /* ---------- view ---------- */
      function updateUi(st) {
        if (st.key !== current) return;
        var shown = st.cards.length;
        var total = knownTotal(st);
        var more = st.buffer.length > 0 || !st.done;
        if (moreWrap) moreWrap.hidden = !more && !st.error;
        if (countEl) {
          countEl.textContent = total != null
            ? (cfg.showing || '').replace('[shown]', shown).replace('[total]', total)
            : (cfg.showingOpen || '').replace('[shown]', shown);
        }
        if (totalEl) totalEl.textContent = total != null ? (cfg.countLabel || '').replace('[total]', total) : '';
        if (emptyEl) emptyEl.hidden = !(st.done && shown === 0 && st.buffer.length === 0);
        var showErr = st.error && st.showError;
        if (errorEl) { errorEl.hidden = !showErr; errorEl.textContent = showErr ? cfg.errorLabel : ''; }
      }
      function setBusy(b) {
        grid.setAttribute('aria-busy', b ? 'true' : 'false');
        root.classList.toggle('is-loading', b);
        if (moreBtn) { moreBtn.disabled = b; moreBtn.setAttribute('aria-busy', b ? 'true' : 'false'); }
        if (moreLabel) moreLabel.textContent = b ? (cfg.loadingLabel || moreText) : moreText;
      }
      function showState(st) {
        var frag = document.createDocumentFragment();
        st.cards.forEach(function (c) { c.classList.remove('is-new'); frag.appendChild(c); });
        grid.replaceChildren ? grid.replaceChildren(frag) : (grid.innerHTML = '', grid.appendChild(frag));
        updateUi(st);
      }
      /* Reveal the next `per` products of the state, loading them first if needed. */
      function reveal(st, focusFirst) {
        setBusy(true);
        return fill(st, per).then(function () {
          if (st.key !== current) return;
          var add = st.buffer.splice(0, per).map(buildCard);
          st.showError = st.error && add.length === 0;
          add.forEach(function (c) { c.classList.add('is-new'); grid.appendChild(c); st.cards.push(c); });
          setBusy(false);
          updateUi(st);
          if (focusFirst && add[0]) {
            var link = add[0].querySelector('.amc-card__title');
            if (link) { try { link.focus({ preventScroll: true }); } catch (e) { link.focus(); } }
          }
          /* Look ahead one extra batch so the button disappears exactly when nothing is left. */
          return fill(st, per * 2).then(function () { updateUi(st); });
        });
      }
      function stateFor(key) {
        if (!states[key]) states[key] = newState(key);
        return states[key];
      }
      function setFilter(key, updateUrl) {
        if (key !== 'all' && !bySlug[key]) key = 'all';
        current = key;
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-amc-pill') === key ? 'true' : 'false'); });
        var st = stateFor(key);
        showState(st);
        if (!st.cards.length) reveal(st, false);
        else fill(st, per * 2).then(function () { updateUi(st); });
        if (updateUrl) {
          try {
            var u = new URL(window.location.href);
            if (key === 'all') u.searchParams.delete('theme'); else u.searchParams.set('theme', key);
            window.history.replaceState(window.history.state, '', u.toString());
          } catch (e) {}
        }
      }

      /* ---------- events ---------- */
      pills.forEach(function (p) {
        p.addEventListener('click', function () { setFilter(p.getAttribute('data-amc-pill'), true); });
      });
      root.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-amc-tag]') : null;
        if (!t || !bySlug[t.getAttribute('data-amc-tag')]) return;
        setFilter(t.getAttribute('data-amc-tag'), true);
        var bar = root.querySelector('[data-amc-pills]');
        if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      if (moreBtn) moreBtn.addEventListener('click', function () {
        var st = stateFor(current);
        st.error = false; st.showError = false;
        reveal(st, true);
      });
      if (sortEl) sortEl.addEventListener('change', function () {
        sort = sortEl.value;
        states = {};
        setFilter(current, false);
      });

      /* ---------- start: All Designs with the server-rendered first batch ---------- */
      var all = stateFor('all');
      adoptServerCards(all);
      var q = '';
      try { q = (new URL(window.location.href).searchParams.get('theme') || '').toLowerCase(); } catch (e) {}
      if (q && bySlug[q]) setFilter(q, false);
      else {
        updateUi(all);
        if (all.cards.length < per) reveal(all, false);
        else fill(all, per * 2).then(function () { updateUi(all); });
      }

      root.__amcSelect = function (slug) { if (bySlug[slug]) setFilter(slug, false); };
      root.__amcStates = function () { return states; };
    }

    function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-amc]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var pill = e.target && e.target.getAttribute && e.target.getAttribute('data-amc-pill');
      var root = e.target && e.target.closest && e.target.closest('[data-amc]');
      if (pill && root && root.__amcSelect) root.__amcSelect(pill);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-cat-more"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function init(root) {
      if (!root || root.__amx) return;
      var row = root.querySelector('[data-amx-row]');
      if (!row) return;
      root.__amx = true;
      var prev = root.querySelector('[data-amx-prev]');
      var next = root.querySelector('[data-amx-next]');
      var ticking = false;

      function cards() { return Array.prototype.slice.call(row.children); }
      function maxScroll() { return Math.max(0, row.scrollWidth - row.clientWidth); }
      /* Where the scroll position must be for a card to sit at the start of the carousel. */
      function startPad() {
        var v = parseFloat(window.getComputedStyle(row).scrollPaddingLeft);
        return isNaN(v) ? 0 : v;
      }
      function targetFor(card) {
        var rowBox = row.getBoundingClientRect();
        var x = card.getBoundingClientRect().left - rowBox.left + row.scrollLeft - startPad();
        return Math.max(0, Math.min(maxScroll(), Math.round(x)));
      }
      function scrollToX(x) {
        try { row.scrollTo({ left: x, behavior: reduced() ? 'auto' : 'smooth' }); }
        catch (e) { row.scrollLeft = x; }
      }
      /* One card per click */
      function step(dir) {
        var now = row.scrollLeft;
        var list = cards();
        var target = null;
        if (dir > 0) {
          for (var i = 0; i < list.length; i++) {
            var t = targetFor(list[i]);
            if (t > now + 4) { target = t; break; }
          }
          if (target == null) target = maxScroll();
        } else {
          for (var j = list.length - 1; j >= 0; j--) {
            var u = targetFor(list[j]);
            if (u < now - 4) { target = u; break; }
          }
          if (target == null) target = 0;
        }
        scrollToX(target);
      }
      function update() {
        ticking = false;
        var max = maxScroll();
        root.classList.toggle('amx--static', max <= 2);
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max - 2;
      }
      function queue() {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || setTimeout)(update);
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', queue, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(queue).observe(row);
      else window.addEventListener('resize', queue);
      update();

      root.__amxShow = function (card) {
        if (card && card.parentNode === row) scrollToX(targetFor(card));
      };
    }

    function boot(scope) {
      var nodes = (scope || document).querySelectorAll('[data-amx]');
      Array.prototype.forEach.call(nodes, init);
      if (scope && scope.matches && scope.matches('[data-amx]')) init(scope);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target && e.target.closest && e.target.closest('.amx-card');
      var root = card && card.closest('[data-amx]');
      if (root && root.__amxShow) root.__amxShow(card);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-cat-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASE = 'cubic-bezier(.42,0,.2,1)';
    function init(root) {
      if (!root || root.__ams) return;
      var stage = root.querySelector('[data-ams-stage]');
      var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-ams-scene]'));
      if (!stage || !scenes.length) return;
      root.__ams = true;
      root.classList.add('is-boot');
      var say = root.querySelector('.ams__say');
      var titleEl = root.querySelector('[data-ams-title]');
      var lineEl = root.querySelector('[data-ams-line]');
      var pauseBtn = root.querySelector('[data-ams-pause]');
      var chapBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ams-go]'));
      var maxScale = parseFloat(root.getAttribute('data-max-scale')) || 1.05;
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      var still = mq.matches;
      var cur = 0, t = 0, paused = still, offscreen = false, fired = {}, last = performance.now(), anims = [], cues = [], F = null, raf = 0;

      function cam(W, H, iw, ih, cx, cy, z) {
        var cover = Math.max(W / iw, H / ih);
        var s = cover * Math.max(1, z);
        s = Math.max(cover, Math.min(s, Math.max(maxScale, cover)));
        var tx = W / 2 - cx * s, ty = H / 2 - cy * s;
        tx = Math.min(0, Math.max(W - iw * s, tx));
        ty = Math.min(0, Math.max(H - ih * s, ty));
        return 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + s.toFixed(4) + ')';
      }
      function img(scene, which) { var ph = scene.querySelector('[data-ams-ph="' + which + '"]'); return ph ? ph.querySelector('img') : null; }
      function frames(scene) {
        var W = stage.clientWidth, H = stage.clientHeight, mobile = W < 600;
        var im = img(scene, 'main');
        var iw = +im.getAttribute('data-w'), ih = +im.getAttribute('data-h');
        var d = scene.dataset;
        var fx = d.fx / 100 * iw, fy = d.fy / 100 * ih;
        var z = (mobile ? +d.zm : +d.zd) / 100;
        var f = { iw: iw, ih: ih, start: cam(W, H, iw, ih, iw / 2, ih / 2, 1) };
        if (d.mode === 'split') {
          var gx = d.f2x / 100 * iw, gy = d.f2y / 100 * ih;
          var hw = (W - 2) / 2;
          var sz = (mobile ? +d.sm : +d.sd) / 100;
          f.end = cam(W, H, iw, ih, (fx + gx) / 2, (fy + gy) / 2, z);
          f.a0 = cam(hw, H, iw, ih, fx, fy, sz * .8); f.a1 = cam(hw, H, iw, ih, fx, fy, sz);
          f.b0 = cam(hw, H, iw, ih, gx, gy, sz * .8); f.b1 = cam(hw, H, iw, ih, gx, gy, sz);
        } else {
          f.end = cam(W, H, iw, ih, fx, fy, z);
        }
        return f;
      }
      function move(el, from, to, dur, delay) {
        if (!el) return;
        if (still || !el.animate) { el.style.transform = to; return; }
        el.style.transform = from;
        var a = el.animate([{ transform: from }, { transform: to }], { duration: dur, delay: delay || 0, easing: EASE, fill: 'both' });
        a._el = el;
        if (paused || offscreen) a.pause();
        anims.push(a);
      }
      function sync() { anims.forEach(function (a) { try { (paused || offscreen || document.hidden) ? a.pause() : a.play(); } catch (e) {} }); }
      function setPaused(p) {
        paused = p; sync();
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', p ? pauseBtn.getAttribute('data-label-play') : pauseBtn.getAttribute('data-label-pause'));
        }
      }
      function message(scene) {
        if (!say) return;
        say.classList.add('is-out');
        setTimeout(function () {
          if (titleEl) titleEl.textContent = scene.dataset.title || '';
          if (lineEl) lineEl.textContent = scene.dataset.line || '';
          say.classList.remove('is-out');
        }, still ? 0 : 450);
      }
      function go(i) {
        cur = (i + scenes.length) % scenes.length; t = 0; fired = {}; cues = [];
        anims.forEach(function (a) { try { a._el.style.transform = getComputedStyle(a._el).transform; a.cancel(); } catch (e) {} });
        anims = [];
        var scene = scenes[cur];
        scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
        F = frames(scene);
        var dur = +scene.dataset.dur || 7000;
        if (scene.dataset.mode === 'split') {
          scene.classList.remove('is-split');
          var ia = img(scene, 'a'), ib = img(scene, 'b');
          if (ia) ia.style.transform = F.a0;
          if (ib) ib.style.transform = F.b0;
          move(img(scene, 'main'), F.start, F.end, dur * .41, 150);
          if (still) { scene.classList.add('is-split'); if (ia) ia.style.transform = F.a1; if (ib) ib.style.transform = F.b1; }
          else cues.push([dur * .38, function () { scene.classList.add('is-split'); move(ia, F.a0, F.a1, dur * .62); move(ib, F.b0, F.b1, dur * .62); }]);
        } else {
          move(img(scene, 'main'), F.start, F.end, Math.max(1000, dur - 600), 200);
        }
        chapBtns.forEach(function (b) {
          var k = +b.getAttribute('data-ams-go');
          b.setAttribute('aria-current', k === cur ? 'true' : 'false');
          var fill = b.querySelector('[data-ams-fill]');
          if (fill) fill.style.width = k < cur ? '100%' : '0';
        });
        message(scene);
      }
      function tick(now) {
        var dt = Math.min(100, now - last); last = now;
        var scene = scenes[cur], dur = +scene.dataset.dur || 7000;
        if (!paused && !offscreen && !document.hidden && scenes.length > 1) {
          t += dt;
          cues.forEach(function (c, k) { if (!fired[k] && t >= c[0]) { fired[k] = true; c[1](); } });
          if (t >= dur) go(cur + 1);
        } else if (!paused && !offscreen && !document.hidden) {
          t = Math.min(dur, t + dt);
          cues.forEach(function (c, k) { if (!fired[k] && t >= c[0]) { fired[k] = true; c[1](); } });
        }
        var p = still ? 1 : Math.min(1, t / dur);
        chapBtns.forEach(function (b) {
          if (+b.getAttribute('data-ams-go') !== cur) return;
          var fill = b.querySelector('[data-ams-fill]');
          if (fill) fill.style.width = (p * 100) + '%';
        });
        raf = requestAnimationFrame(tick);
      }

      chapBtns.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-ams-go')); }); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
      var sx = null, sy = null;
      stage.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('button')) return; sx = e.clientX; sy = e.clientY; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      });
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { offscreen = !es[0].isIntersecting; sync(); }, { threshold: .15 }).observe(stage);
      }
      var ready = false, rw = 0, rh = 0;
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          var w = stage.clientWidth, h = stage.clientHeight;
          if (ready && (Math.abs(w - rw) > 2 || Math.abs(h - rh) > 2)) go(cur);
          rw = w; rh = h;
        }).observe(stage);
      }
      var onMq = function (e) { still = e.matches; root.classList.toggle('is-still', still); setPaused(still); go(cur); };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

      root.classList.toggle('is-still', still);
      setPaused(paused);
      go(0);
      ready = true; rw = stage.clientWidth; rh = stage.clientHeight;
      raf = requestAnimationFrame(tick);
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('is-boot'); }); });

      root.__amsGo = function (i) { go(i); setPaused(true); };
      root.__amsStop = function () { cancelAnimationFrame(raf); anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); };
    }
    function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ams]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var r = e.target && e.target.querySelector && e.target.querySelector('[data-ams]');
      if (r && r.__amsStop) r.__amsStop();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var scene = e.target && e.target.closest && e.target.closest('[data-ams-scene]');
      var root = scene && scene.closest('[data-ams]');
      if (!root || !root.__amsGo) return;
      var all = Array.prototype.slice.call(root.querySelectorAll('[data-ams-scene]'));
      root.__amsGo(all.indexOf(scene));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
